import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import PageTitleWrapper from "../../HOC/page-title";
import StatisticsSearch from "../../components/statistics-search";
import StatisticsExport from "../../components/statistics-export";
import "./statistics-reports.scss";
import StatisticsPage1 from "../../components/statistics-page1";
import StatisticsPage2 from "../../components/statistics-page2";

const StatisticsAndReports = ({ handleChangeKey }) => {
  const [page, setPage] = useState(0);
  useEffect(() => {
    handleChangeKey(1);
  }, []);

  const handleChangePage = (val) => {
    setPage(val);
  };
  return (
    <div className="statistics-reports-container">
      <Row className="statistics-row-container" gutter={16}>
        <Col className="gutter-row" xxl={16} xl={16} lg={16} md={14} sm={24} xs={24}>
          <StatisticsSearch />
        </Col>
        <Col className="gutter-row" xxl={8} xl={8} lg={8} md={10} sm={24} xs={24}>
          <StatisticsExport excelUrl="" wordUrl="" pdfUrl="" />
        </Col>
      </Row>
      {page === 0 ? (
        <StatisticsPage1 handleChangePage={handleChangePage} page={page} />
      ) : (
        <StatisticsPage2 handleChangePage={handleChangePage} page={page} />
      )}
    </div>
  );
};

export default PageTitleWrapper(StatisticsAndReports);
